import { render, staticRenderFns } from "./VirtualServerService.vue?vue&type=template&id=1c7279dc&"
import script from "./VirtualServerService.vue?vue&type=script&lang=js&"
export * from "./VirtualServerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports